import { FullWidthComponent } from './full-width/full-width.component';
import { ColumnViewComponent } from './column-view/column-view.component';
import { BlankAsideComponent } from './blank-aside/blank-aside.component';
import { DefaultComponent } from './default/default.component';

export const LAYOUTS = [BlankAsideComponent, DefaultComponent, ColumnViewComponent, FullWidthComponent];



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/layouts/components/layouts.ts